import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { take, takeUntil } from "rxjs/operators";
import { HrmDiskFormat } from "../../../models/base-info/hrm-disk-format.model";
import { HrmReportPrintKind } from "../../../models/enums/round-kind";

@Component({
  selector: "ngx-hrm-disk-format-export",
  templateUrl: "./hrm-disk-format-export.component.html",
  styleUrls: ["./hrm-disk-format-export.component.scss"],
})
export class HrmDiskFormatExportComponent extends BaseFormComponent<HrmDiskFormat> {
  public apiName: string = "HrmLoanKind";
  isOk: boolean = false;
  @Input() IssueYear: number;
  @Input() IssueMonth: number;
  WorkplaceIds: number[] = []; //محل خدمت
  OrganizationalUnitIds: number[] = []; //واحد سازمانی
  EmploymentKindIds: number[] = []; //انواع استخدام
  HrmBankIds: number[] = []; //محل پرداخت
  InsPayCompaniesIds: number[] = [];
  TaxPayCompaniesIds: number[] = [];
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private splashFormService: SplashFormService,
    private lookupservice: LookupService
  ) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = "ساخت فایل خروجی";
    this.noLoadData = true;
    super.ngOnInit();
  }
  setdefault() {
    if (this.isNewRow === true && !this.model.ANSICode) this.model.ANSICode = false;
    if (this.isNewRow === true && !this.model.HasRowHeader) this.model.HasRowHeader = false;
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    this.columns.forEach((x) => {
      // if(x.name !== 'DiskFormatTitle' && x.name !== 'FileName' && x.name !== 'HrmDiskFormatOutPutKindTitle' && x.name !== 'ANSICode')
      //   x.formVisible = false;
      x.required = false;
      if (x.name !== "FileName" && x.name !== "ANSICode") x.disabled = true;
      if (x.name === "ANSICode") x.columnNumber = 5;
    });
    if (!this.orignalColumns.some((x) => x.name === "HrmReportPrintKind"))
      this.orignalColumns.push(<form_control>{
        label: "نوع گزارش",
        controlType: FormControlTypes.dropdown,
        modelName: "HrmReportPrintKind",
        disabled: false,
        name: "HrmReportPrintKind",
        order: 2,
        textType: "text",
        formVisible: true,
        listVisible: true,
        required: true,
        columnNumber: 6,
        userClass: "select-sm",
        apiName: "Lookup",
        systemName: "HRM",
        category: "HrmReportPrintKind",
        valueMember: "Code",
        displayMember: "Title",
      });
    if (!this.columns.some((x) => x.name === "HrmReportPrintKind"))
      this.columns.push(<form_control>{
        label: "نوع گزارش",
        controlType: FormControlTypes.dropdown,
        modelName: "HrmReportPrintKind",
        disabled: false,
        name: "HrmReportPrintKind",
        order: 2,
        textType: "text",
        formVisible: true,
        listVisible: true,
        required: true,
        columnNumber: 6,
        userClass: "select-sm",
        apiName: "Lookup",
        systemName: "HRM",
        category: "HrmReportPrintKind",
        valueMember: "Code",
        displayMember: "Title",
      });
  }
  addControl() {
    this.isOk = false;
    this.lookupservice
      .getLookupbyCode("HRM", "HrmReportPrintKind", HrmReportPrintKind.BillPayAll)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((rk) => {
        this.setValue("HrmReportPrintKind", rk.Code, true);
      });
    this.setValue("HrmBankIds", this.HrmBankIds);
    this.setValue("EmploymentKindIds", this.EmploymentKindIds);
    this.setValue("OrganizationalUnitIds", this.OrganizationalUnitIds);
    this.setValue("WorkplaceIds", this.WorkplaceIds);
    this.setValue("TaxPayCompaniesIds", this.TaxPayCompaniesIds);
    this.setValue("InsPayCompaniesIds", this.InsPayCompaniesIds);
    this.isOk = true;
  }
  saveTextAsFile(data, filename) {
    if (!data) {
      console.error("Console.save: No data");
      return;
    }
    if (!filename) filename = "FileName.txt";
    this.isSaving = false;
    var blob = new Blob([data], { type: "text/plain" }),
      e = document.createEvent("MouseEvents"),
      a = document.createElement("a");
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(blob, filename);
    } else {
      var e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/plain", a.download, a.href].join(":");
      e.initEvent("click", true, false);
      a.dispatchEvent(e);
    }
  }
  downloadExcelFile(response: any): void {
    let contentDisposition = response.headers.get("Content-Disposition");
    let filename = "";
    if (contentDisposition) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }

    if (!filename && this.reportName) {
      filename = this.reportName;
    }

    let dataType = response.body.type;
    let binaryData = [];
    binaryData.push(response.body);
    let downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
    if (filename) downloadLink.setAttribute("download", filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  public async save() {
    try {
      if (!this.isSaving) {
        if (this.isValid()) {
          this.sts.showToast("info", "", "در حال ساخت فایل...");
          this.isSaving = true;
          this.isSaved = false;
          if (this.model.HrmDiskFormatOutPutKindCode === 2) {
            await this.httpCommonService
              .getExcel("HrmDiskFormat/ExportToExcel", this.getFilter())
              .pipe(take(1))
              .toPromise()
              .then(
                (response: any) => {
                  this.downloadExcelFile(response);
                  this.splashFormService.closeLoading();
                },
                () => {
                  this.splashFormService.closeLoading();
                }
              );
          } else {
            await this.httpCommonService
              .create("HrmDiskFormat/HrmDiskFormatExport", this.getFilter())
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (response) => {
                  if (response && this.model.HrmDiskFormatOutPutKindCode === 2) {
                    this.downloadExcelFile(response);
                  }
                  if (response && this.model.HrmDiskFormatOutPutKindCode === 1) {
                    this.saveTextAsFile(response.Text, this.model.FileName);
                  }
                  this.saveSuccessHelper();
                },
                (error) => this.saveFailedHelper(error)
              );
          }
        } else {
          this.selectorService.submitted$.next(this.submitted);
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }
  getFilter(): GridFilter[] {
    let filter: GridFilter[] = [];
    filter.push({ Filed: "HrmDiskFormatId", Value: this.model.Id, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    filter.push({ Filed: "IssueYear", Value: this.IssueYear, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    filter.push({ Filed: "IssueMonth", Value: this.IssueMonth, Operator: "eq", Type: "F", Skip: 0, Take: 0 });
    if (this.formGroup?.get("InsPayCompaniesIds")?.value && this.formGroup?.get("InsPayCompaniesIds")?.value > 0) {
      filter.push({
        Filed: "InsPayCompaniesIds",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("InsPayCompaniesIds")?.value,
        Logic: "and",
      });
    }
    if (this.formGroup?.get("TaxPayCompaniesIds")?.value && this.formGroup?.get("TaxPayCompaniesIds")?.value > 0) {
      filter.push({
        Filed: "TaxPayCompaniesIds",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("TaxPayCompaniesIds")?.value,
        Logic: "and",
      });
    }
    if (this.formGroup?.get("HrmBankIds")?.value && this.formGroup?.get("HrmBankIds")?.value.length > 0) {
      filter.push({
        Filed: "HrmBankIds",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("HrmBankIds")?.value,
        Logic: "and",
      });
    }
    if (this.formGroup?.get("EmploymentKindIds")?.value && this.formGroup?.get("EmploymentKindIds")?.value.length > 0) {
      filter.push({
        Filed: "EmploymentKindIds",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("EmploymentKindIds")?.value,
        Logic: "and",
      });
    }
    if (this.formGroup?.get("OrganizationalUnitIds")?.value && this.formGroup?.get("OrganizationalUnitIds")?.value.length > 0) {
      filter.push({
        Filed: "OrganizationalUnitIds",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("OrganizationalUnitIds")?.value,
        Logic: "and",
      });
    }
    if (this.formGroup?.get("WorkplaceIds")?.value && this.formGroup?.get("WorkplaceIds")?.value.length > 0) {
      filter.push({
        Filed: "WorkplaceIds",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("WorkplaceIds")?.value,
        Logic: "and",
      });
    }
    if (this.formGroup?.get("HrmReportPrintKind")?.value && this.formGroup?.get("HrmReportPrintKind")?.value > 0) {
      filter.push({
        Filed: "HrmReportPrintKind",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup.controls["HrmReportPrintKind"].value,
        Logic: "and",
      });
    }
    return filter;
  }
}
